import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

export interface Data {
  name: string;
  target: any;
  [key: string]: any;
}

/**
 * This shared component displays the connection
 * between data with the help of connector
 * 
 * @author Mohsin Shaikh
 * @since June 2023
 */
@Component({
  selector: 'app-mat-chip',
  templateUrl: './mat-chip.component.html',
  styleUrls: ['./mat-chip.component.scss']
})

export class MatChipComponent implements OnInit {

  /****************** View child ******************/
  @ViewChild('chipContainer', { static: true }) chipContainer: ElementRef<HTMLDivElement>;

  /****************** Input and Output decorators ******************/
  @Input() title: string;
  @Input() dataSource: Data[];
  @Output() chipClicked: EventEmitter<Data> = new EventEmitter();

  /************************* view box *************************/
  viewBoxMinX: number;
  viewBoxMinY: number;
  viewBoxWidth: number;
  viewBoxHeight: number;
  // viewBoxValue: string;
  /************************* view box *************************/

  /************************ chip info ************************/
  readonly chipY = 0;
  readonly chipWidth = 280;
  readonly chipHeight = 50;
  /************************ chip info ************************/

  /********************** chip box info **********************/
  readonly chipBoxX = 5;
  readonly chipBoxY = 1;
  readonly chipBoxWidth = (this.chipWidth * 96) / 100;
  readonly chipBoxHeight = (this.chipHeight * 96) / 100;
  readonly chipBoxMidY = (this.chipBoxHeight * 50) / 100;
  /********************** chip box info **********************/

  /********************** connector info *********************/
  readonly connectorTransform = `translate(${this.chipBoxX + this.chipBoxWidth}, 0)`
  readonly connectorLen = 40;
  readonly connectorDotRadius = 4.5;
  /********************** connector info *********************/

  readonly chipX = (this.chipBoxX + this.chipBoxWidth) + (this.connectorLen - this.connectorDotRadius);

  /*************************** zoom **************************/
  zoomLevel = 1;
  zoomStep = 0.1;
  maxZoom = 1;
  minZoom = 0.3;
  /*************************** zoom **************************/

  /**
   * intialization method
   */
  ngOnInit(): void {
    let chipContainer = this.chipContainer.nativeElement;
    this.viewBoxMinX = (chipContainer.clientWidth * -5) / 100;
    this.viewBoxMinY = ((chipContainer.clientHeight / 2) - (this.chipHeight / 2)) * -1;
    this.viewBoxWidth = (this.chipWidth * this.dataSource.length) + (this.connectorLen * (this.dataSource.length - 1)) + Math.abs(this.viewBoxMinX);
    this.viewBoxHeight = chipContainer.clientHeight;
  }

  /**
   * add data to datasource
   * @param data data
   * @returns datasource
   */
  addData(data: Data) {
    let index = this.dataSource.indexOf(data.target);
    this.dataSource.splice(index >= 0 ? index + 1 : this.dataSource.length, 0, data);
    return this.dataSource;
  }

  /**
   * getter for viewbox value
   * @returns viewbox value 
   */
  getViewBoxValue() {
    return `${this.viewBoxMinX} ${this.viewBoxMinY} ${this.viewBoxWidth * this.zoomLevel} ${this.viewBoxHeight}`
  }

  /**
   * get connector value in svg by index of data
   * @returns translate value for connector
   */
  getConnectorTransformValue(index: number): string {
    return `translate(${((this.chipBoxX + this.chipBoxWidth) * index) + (index > 1 ? (this.connectorLen - this.connectorDotRadius) * (index - 1) : 0)}, 0)`
  }

  /**
   * handles zoom event
   * @param event wheel event
   */
  onZoom(event: WheelEvent) {
    if (event.ctrlKey) {
      event.preventDefault();

      if (event.deltaY > 0 && this.zoomLevel < this.maxZoom) {
        this.zoomLevel += this.zoomStep
      } else if (event.deltaY < 0 && this.zoomLevel > this.minZoom) {
        this.zoomLevel -= this.zoomStep;
      }
    }
  }
}
